import React from 'react'
import moment from 'moment';
import {Col, Row} from "react-bootstrap";

import BizLocationSelector from "../../component/BizLocation/BizLocationSelector";
import {DateRangeSelector} from '../../component/Date/DateRangeSelector';
import {dayMonthYear} from "../../utils/dates";
import {Link} from "react-router-dom";
import {mapItems} from "../../productType/component/ProductTypeSelector";

class MovementByProductTypeGird {
  showNewButton = false;
  showPdfButton = false;
  exportNewPage = true;

  defaultSort = 'date';

  sortOrderToDownloadContent = 'DESC';

  customFilters = {startDate: moment().subtract(6, 'days').toDate(), endDate: new Date()};

  title = "Movimentação de Itens"

  columns = [
    {
      Header: 'Referência',
      accessor: 'productType.reference',
      Cell: (row) => {
        const params = new URLSearchParams({})
        const {productType, date} = row.original;
        const {bizLocationIn, bizLocationOut} = this.customFilters;

        bizLocationOut && params.append('bizLocationOutId', bizLocationOut.id);
        bizLocationOut && params.append('bizLocationOutName', bizLocationOut.friendlyName);

        bizLocationIn && params.append('bizLocationInId', bizLocationIn.id);
        bizLocationIn && params.append('bizLocationInName', bizLocationIn.friendlyName);

        params.append('productTypeId', productType.id);
        date && params.append('date', date);
        params.append('productTypeReferenceOrFriendlyName', mapItems(productType).referenceOrFriendlyName);

        const search = params.toString();
        return <Link Link to={{
          pathname: '/list/movement-order-by-transaction',
          search: search
        }}>{productType.reference}</Link>
      }
    },
    {
      Header: 'Nome',
      accessor: 'productType.friendlyName',
      HeaderColumn: true,
      Cell: (row) => row.original.productType
          ? row.original.productType.friendlyName : ''
    },
    {
      Header: 'Quantidade',
      accessor: 'total',
      Cell: (row) => row.original.total
    },
    {
      Header: 'Dia',
      accessor: 'date',
      Cell: row => (row.original.date && dayMonthYear(row.original.date))
    }
  ]

  endpoint = (props, state) => {
    const params = new URLSearchParams({});
    const {bizLocationOut, bizLocationIn, startDate, endDate} = this.customFilters;
    bizLocationOut && params.append('_bizLocationIdOut', bizLocationOut.id);
    bizLocationIn && params.append('_bizLocationIdIn', bizLocationIn.id);
    startDate && params.append('startDate', this.customFilters.startDate.toISOString());
    endDate && params.append('endDate', this.customFilters.endDate.toISOString());
    return `ton/v1/movements/product-types?${params.toString()}`;
  };

  customFilterComponent = (props, state, onChange) => <Row>
    <Col lg={4}>
      <BizLocationSelector title="Local Origem"
                           onChange={value => {
                             this.customFilters.bizLocationOut = value;
                             onChange(value);
                           }}/>
    </Col>
    <Col lg={4}>
      <BizLocationSelector
          title="Local Destino"
          onChange={value => {
            this.customFilters.bizLocationIn = value;
            onChange(value);
          }}/>
    </Col>
    <Col lg={4}>
      <DateRangeSelector
          onChange={(startDate, endDate) => {
            this.customFilters.startDate =startDate;
            this.customFilters.endDate =endDate;
            onChange({startDate, endDate})
          }}
          defaultStartDate={this.customFilters.startDate}
      />
    </Col>
  </Row>
}

export default MovementByProductTypeGird;



// WEBPACK FOOTER //
// ./src/customGrid/entities/MovementByProductTypeGird.js